import { ComponentPortal } from '@angular/cdk/portal';

import { BaseModel } from '../../core/abstractions/base.model';
import { RelatedItemModel } from './related-item.model';

export class TabLoadedInstanceModel extends BaseModel {
    portal: ComponentPortal<any>;
    actions: RelatedItemModel[] = [];

    constructor(init?: Partial<TabLoadedInstanceModel>) {
        super();
        Object.assign(this, init);
    }
}
